import KeyVal from '@util/KeyVal';

class Config extends KeyVal {
  public apiUrl: string;
  public apiBaseUrl: string;
  public ssoClientUrl: string;
  public credentialsAllowed: boolean;
  public componentTier: string;
  public teliaSelfServiceUrl: string;
  public teliaUrl: string;
  public smUrl: string;
  public ivrUrl: string;
  public controlUrl: string;
  public suspicionUrl: string;
  public mapRefreshIntervalMs: number;

  public initialize(config: InitialConfig) {
    this.apiUrl = config.apiUrl;
    this.ssoClientUrl = config.ssoClientUrl;
    this.credentialsAllowed = config.credentialsAllowed;
    this.componentTier = config.componentTier;
    this.teliaSelfServiceUrl = config.teliaSelfServiceUrl;
    this.teliaUrl = config.teliaUrl;
    this.apiBaseUrl = `${config.teliaUrl}/api`;
    this.smUrl = `${config.smUrl}/index.do?ctx=docEngine`;
    this.ivrUrl = config.ivrUrl;
    this.controlUrl = `${config.teliaUrl}/abi/diagnostika`;
    this.suspicionUrl = `${config.teliaUrl}/abi/service-suspicion`;
    this.mapRefreshIntervalMs = config.mapRefreshIntervalMs || 60000;
  }
}

export default new Config();
